import Contact, {ApiContact, ApiContactSubmitData, ContactFilters, DetailContactFilters} from '@/model/Contact';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {parseGenericFilters} from '../meta/filters';
import {ApiCombination, ApiComparison, ApiSortsDerived} from '../meta/odata';
import {ResourceKunde} from './provider';


export enum ResourceAnsprechpartner {
  Ansprechpartner = '/Kunde/ansprechpartner',
}

export async function getContacts(
    filters: ContactFilters, sorts: ApiSortsDerived<ApiContact>,
    limit: number | null = null, skip: number = 0,
): Promise<CombinedApiResponse<Contact[]>> {
  const convertedFilters = parseGenericFilters({...filters});
  const response = await doApiRequest<ApiContact[]>({
    method: Method.Get,
    resource: ResourceAnsprechpartner.Ansprechpartner,
    module: Module.Kunde,
    filters: [
      ApiCombination.And,
      convertedFilters,
      [ApiComparison.GreaterThanEqual, {field: 'AnsprechpartnerNr'}, 0],
    ],
    select: new Set([
      'Nummer',
      'AnsprechpartnerNr',
      'KundenNr',
      'Vorname',
      'Nachname',
      'Position',
      'Ausgeschieden',
    ]),
    sorts,
    limit,
    skip,
  });

  return [response.Data.map((p) => Contact.fromApi(p)), response.CountAll];
}

export async function getDetailContact(
    filters: DetailContactFilters,
): Promise<CombinedApiResponse<Contact|null>> {
  const response = await doApiRequest<ApiContact[]>({
    method: Method.Get,
    resource: ResourceAnsprechpartner.Ansprechpartner,
    module: Module.Kunde,
    filters: parseGenericFilters({...filters/* , KundStatus: KundStatus.Active */}),
    select: new Set([
      'Anrede',
      'Briefanrede',
      'Nachname',
      'Vorname',
      'Abteilung',
      'Position',
      'AustrittDatum',
      'AufgabenGebiet',
      'Strasse',
      'Ort',
      'Plz',
      'Telefon1',
      'Telefon2',
      'Telefax',
      'Email',
      'AnsprechpartnerNr',
      'Homepage',
      'Info1',
      'Info2',
      'Ausgeschieden',
    ]),
  });

  return response.Data.length ? [Contact.fromApi(response.Data[0])] : [null];
}

export async function postContact(
    KundenNr: number,
    data: ApiContactSubmitData[],
): Promise<Contact> {
  const response = await doApiRequest({
    module: Module.Kunde,
    resource: ResourceKunde.Kunde,
    method: Method.Post,
    id: `${KundenNr}/ansprechpartner`,
    data,
  });

  return Contact.fromApi(response.Data[0]);
}

export async function putContact(
    KundenNr: number,
    contactId: number,
    data: ApiContactSubmitData,
): Promise<Contact> {
  const response = await doApiRequest({
    module: Module.Kunde,
    resource: ResourceKunde.Kunde,
    method: Method.Put,
    id: `${KundenNr}/ansprechpartner/${contactId}`,
    data,
  });

  return Contact.fromApi(response.Data[0]);
}
